import { goTo, goToQuestion, goToReading } from '../../../common/navigation/navigationActions';
import { LC } from '../../../constants/measure';
import { onLCQuestionChange, saveComprehensionResponse, setPassageHalf } from '../../lcActions';
import selectors from '../../../rootSelectors';
import { FIRST, SECOND } from '../../lcConstants';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playResponseAudio, resetSelectedIndex } from '../../../common/questions/questionsActions';
import { GENERAL_AUDIO_DELAY, ONE_SECOND } from '../../../constants/time';
import { OWLY_INTERSTITIAL } from '../../../constants/url';
import { setPlaylistItemCompleted } from '../../../common/playlist/playlistActions';
import { deactivateNextButton } from '../../../common/screen/screenActions';


const INCREMENT = 1;
const LAST_QUESTION_INDEX = 4;

export const playQuestionAndResponses = (stimulusAudio, possibleResponses) => async (dispatch) => {
    await dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    await dispatch(playResponseAudio(possibleResponses[0].audio, 0, ONE_SECOND));
    await dispatch(playResponseAudio(possibleResponses[1].audio, 1, ONE_SECOND));
    await dispatch(playResponseAudio(possibleResponses[2].audio, 2, ONE_SECOND));
};

const onNextButtonClick = questionIndex => (dispatch, getStore) => {
    const state = getStore();
    const passageHalf = selectors.getLCPassageHalf(state);
    const isLastQuestion = questionIndex === LAST_QUESTION_INDEX;

    return dispatch(saveComprehensionResponse(questionIndex, isLastQuestion)).then(() => {

        if (isLastQuestion && passageHalf === FIRST) {
            dispatch(resetSelectedIndex());
            dispatch(deactivateNextButton());
            dispatch(setPassageHalf(SECOND));
            return dispatch(goToReading(LC.ASSESSMENT));
        }

        if (isLastQuestion && passageHalf === SECOND) {
            dispatch(resetSelectedIndex());
            dispatch(deactivateNextButton());
            dispatch(setPlaylistItemCompleted(LC.MEASURE));
            return dispatch(goTo(OWLY_INTERSTITIAL));
        }

        const nextQuestionIndex = questionIndex + INCREMENT;
        const nextQuestion = nextQuestionIndex + INCREMENT;

        dispatch(onLCQuestionChange(nextQuestionIndex));
        return dispatch(goToQuestion(LC.ASSESSMENT, null, nextQuestion));
    });
};

export default onNextButtonClick;
